import { useInfoPanelQueries } from './useInfoPanelQueries';
import useSidebarActions from './useSidebarActions';
import { useTreatmentEvents } from './useTreatmentEvents';

export type usFileEntryViewerStoreProps = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  documentFileId: number;
};

const useFileEntryViewerStore = ({ projectId, inboxEntryId, fileId }) => {
  const sidebarActions = useSidebarActions({
    fileId,
    inboxEntryId: inboxEntryId,
    projectId,
  });
  const infoPanelQueries = useInfoPanelQueries({ sourceId: inboxEntryId });
  const treatmentEvents = useTreatmentEvents({ inboxEntryId });

  return {
    sidebarActions,
    infoPanelQueries,
    treatmentEvents,
  };
};

export default useFileEntryViewerStore;
